var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "en_item flex_space flex_center_align" }, [
    _c("div", { staticClass: "company" }, [
      _vm._v("フォーティーセカンド・ストリート株式会社"),
    ]),
    _c(
      "div",
      { staticClass: "flex_start tzx_right flex_end" },
      [
        _c("div", { staticClass: "name" }, [_vm._v("担当者")]),
        _c("div", { staticClass: "ddz flex_colum flex_start" }, [
          _c(
            "div",
            { staticClass: "ddz_item flex_start" },
            [
              _c("vab-select", {
                attrs: {
                  "label-width": "0",
                  placeholder: "選択されていません",
                  prop: "ddz",
                  "data-key": "ddzconst",
                  "label-id": "label",
                  "value-id": "value",
                  "data-type": "local",
                  clearable: "",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._t("del", function () {
          return [
            _c(
              "div",
              { staticClass: "del_box flex_center_align flex_center" },
              [
                _c(
                  "div",
                  _vm._g(
                    { staticClass: "del_inner flex_center_align flex_center" },
                    _vm.$listeners
                  ),
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/close.png"),
                        alt: "",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }